import Cookies from "js-cookie";
import { DOMAIN_SESSION_STORAGE_KEY } from "../pages/HomePage/constants";

/** Legacy DOMAIN cookie; migrated into sessionStorage on first read. */
const LEGACY_DOMAIN_COOKIE_KEY = "DOMAIN";

export function loadPersistedDomain(): string | null {
  try {
    if (typeof window === "undefined") return null;

    const fromSession = window.sessionStorage.getItem(
      DOMAIN_SESSION_STORAGE_KEY,
    );
    if (fromSession) return fromSession;

    const fromCookie = Cookies.get(LEGACY_DOMAIN_COOKIE_KEY);
    if (fromCookie) {
      persistDomain(fromCookie);
      return fromCookie;
    }

    return null;
  } catch {
    return null;
  }
}

export function persistDomain(domain: string): void {
  try {
    if (typeof window === "undefined") return;
    window.sessionStorage.setItem(DOMAIN_SESSION_STORAGE_KEY, domain);
  } catch {
    // ignore storage failures (privacy mode, blocked storage, etc.)
  }
}

export function clearPersistedDomain(): void {
  try {
    if (typeof window === "undefined") return;
    window.sessionStorage.removeItem(DOMAIN_SESSION_STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Read `domain` from the current page URL (or an explicit href). */
export function readDomainFromUrl(href?: string): string | null {
  try {
    if (typeof window === "undefined" && !href) return null;
    const url = href
      ? new URL(
          href,
          typeof window !== "undefined"
            ? window.location.origin
            : "http://localhost",
        )
      : new URL(window.location.href);
    const v = url.searchParams.get("domain")?.trim();
    return v || null;
  } catch {
    return null;
  }
}

/**
 * Effective domain for navigation: explicit > URL ?domain= > sessionStorage.
 */
export function resolveEffectiveDomain(options?: {
  explicit?: string | null;
  urlSearch?: URLSearchParams | null;
  href?: string;
}): string | null {
  const explicit = options?.explicit?.trim();
  if (explicit) return explicit;

  const fromParams = options?.urlSearch?.get("domain")?.trim();
  if (fromParams) return fromParams;

  const fromUrl = options?.href
    ? readDomainFromUrl(options.href)
    : readDomainFromUrl();
  if (fromUrl) return fromUrl;

  return loadPersistedDomain();
}
